<template>
  <Modal
    :title="$t('customize_content_block')"
    :form="{
      data: form,
      method: 'PUT',
      endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise`
    }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('title')"
      name="title"
    >
      <TextInput
        v-model="form.title"
        name="title"
      />
    </InputGroup>

    <MarkdownInput
      v-model="form.synopsis"
      :label="$t('text')"
      name="synopsis"
      rows="12"
    />
  </Modal>
</template>

<script setup lang="ts">
import type { ContentBlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<ContentBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  title: data.value.item.title,
  synopsis: data.value.item.synopsis
})
</script>
